<template>
  <div class="start">
    <div class="back-nav"></div>
    <h1 class="start__title">Teckna elavtal på 2 minuter!</h1>
    <p class="start__subtitle">Vad roligt att du hittat hit! Här hjälper vi dig beräkna din månadskostnad och teckna ett elavtal på fyra enkla steg.</p>
    <div class="start__selector">
      <p class="start__selector-intro">Starta här</p>
      <h2 class="start__selector-text">Jag bor i <a href="#">Borås</a></h2>
      <p class="start__selector-subtitle">Klicka för att ändra postnummer</p>
      <router-link class="button button--with-icon start__selector-link" :to="{ name: 'elpris' }">
        Beräkna ditt elpris
        <Arrow />
      </router-link>
    </div>
    <div class="start__counter">
      <div class="start__counter-graph">
        <svg viewBox="0 0 36 36">
          <path
            d="M18 2.0845
              a 15.9155 15.9155 0 0 1 0 31.831
              a 15.9155 15.9155 0 0 1 0 -31.831"
              class="start__counter-graph-track"
          />
          <path
            d="M18 2.0845
              a 15.9155 15.9155 0 0 1 0 31.831
              a 15.9155 15.9155 0 0 1 0 -31.831"
            stroke-dasharray="93, 100"
            class="start__counter-graph-line"
          />
        </svg>
        <div class="start__counter-graph-label">93%</div>
      </div>
      <p class="start__counter-text">Visste du att Borås Elhandel har 93% nöjda kunder?<br>
      Bli en nöjd kund du också.</p>
    </div>
    <div class="start__info-wrapper">
      <div class="start__info">
        <img src="@/assets/images/schysst_elhandel.jpg"
        srcset="@/assets/images/schysst_elhandel@2x.jpg 2x, @/assets/images/schysst_elhandel@3x.jpg 3x"
        alt=""
        class="start__info-image">
        <h3 class="start__info-title">Schysst elhandel</h3>
        <p class="start__info-text">Certifikatet ”Schysst Elhandel” betyder att vi har kriterier och kundlöften som gör det enklare för dig som kund att känna dig trygg i avtal med oss.</p>
        <a class="start__info-link rounded-button" href="https://example.com">Läs mer</a>
      </div>
      <div class="start__info">
        <img src="@/assets/images/fast_eller_rorligt.jpg"
        srcset="@/assets/images/fast_eller_rorligt@2x.jpg 2x, @/assets/images/fast_eller_rorligt@3x.jpg 3x"
        alt=""
        class="start__info-image">
        <h3 class="start__info-title">Fast eller rörligt pris?</h3>
        <p class="start__info-text">Är du aktiv och följer elmarknaden passar ett rörligt elpris. Vill du veta vad du betalar för elen och värderar trygghet är fast elpris ett bättre alternativ. </p>
        <a class="start__info-link rounded-button" href="https://example.com">Läs mer</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss">
  .start {
    text-align: center;
    &__title {
      margin: 0;
      color: $secondary-text-color;
      @include font-primary(bold);
      @include media('>lg') {
        font-size: rem(56);
        line-height: (66/56);
      }
      @include media('<=lg') {
        font-size: rem(36);
        line-height: (44/36);
      }
    }
    &__subtitle {
      margin: 0;
      @include media('>lg') {
        margin-top: rem(25);
        font-size: rem(22);
        line-height: (32/22);
      }
      @include media('<=lg') {
        margin-top: rem(9);
        font-size: rem(18);
        line-height: (25/18);
      }
    }
    &__selector {
      background: $light-bg-color;
      color: $secondary-text-color;
      @include media('>lg') {
        padding: rem(20) rem(24) rem(30);
        margin: rem(55) 0 rem(33);
      }
      @include media('<=lg') {
        padding: rem(15) rem(16) rem(19);
        margin: rem(27) rem(-16) rem(25) rem(-16);
      }
    }
    &__selector-intro {
      margin: 0;
      @include font-primary(bold);
      font-size: rem(18);
    }
    &__selector-text {
      margin: rem(13) 0 rem(10);
      @include font-primary(bold);
      font-size: rem(26);
      a {
        color: $primary-color;
        &:hover,
        &:focus {
          color: $dark-primary-color;
        }
      }
    }
    &__selector-subtitle {
      margin: rem(13) 0 rem(10);
      font-size: rem(13);
      @include media('>lg') {
        @include font-primary(roman);
      }
      @include media('<=lg') {
        @include font-primary(light);
      }
    }
    &__selector-link {
      @include media('>lg') {
        margin-top: rem(33);
      }
      @include media('<=lg') {
        margin-top: rem(28);
      }
    }
    &__counter {
      @include media('>lg') {
        margin-bottom: rem(43);
      }
      @include media('<=lg') {
        margin-bottom: rem(37);
      }
    }
    &__counter-graph {
      position: relative;
      svg {
        transform: rotate(-180deg) scaleX(-1);
        width: rem(75);
        height: rem(75);
        display: block;
        margin: 0 auto;
      }
    }
    &__counter-graph-label {
      @include font-primary(bold);
      font-size: rem(18);
      line-height: 1;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    &__counter-graph-track,
    &__counter-graph-line {
        fill: none;
        stroke-width: 4;
    }
    &__counter-graph-track {
      stroke: $main-text-color;
    }
    &__counter-graph-line {
      stroke: $secondary-color;
    }
    &__counter-text {
      margin: rem(19) 0 0;
      @include media('>lg') {
        font-size: rem(18);
      }
      @include media('<=lg') {
        font-size: rem(15);
        line-height: (23/15)
      }
    }
    &__info-wrapper {
      @include media('>lg') {
        display: flex;
        margin: 0 rem(-12);
      }
    }
    &__info {
      @include media('>lg') {
        flex: 1 1;
        padding: 0 rem(12) rem(32);
      }
      @include media('<=lg') {
        padding-bottom: rem(24);
      }
      color: $secondary-text-color;
    }
    &__info-image {
      display: block;
      margin: 0 auto;
      @include media('>lg') {
        width: rem(100);
        margin-bottom: rem(14);
      }
      @include media('<=lg') {
        margin-bottom: rem(17);
        width: rem(80);
      }
    }
    &__info-title {
      @include font-primary(bold);
      margin: 0;
      @include media('>lg') {
        font-size: rem(26);
      }
      @include media('<=lg') {
        font-size: rem(22);
      }
    }
    &__info-text {
      @include font-primary(roman);
      margin: rem(3) 0 rem(15);
      @include media('>lg') {
        font-size: rem(16);
        line-height: (24/16);
      }
      @include media('<=lg') {
        font-size: rem(15);
        line-height: (23/15);
      }
    }
  }
</style>
